<template>

    <FloatingPanel title="Nieuws">

        <div class="canvas::blocks-modules-news-BlockPanel">

            <Tabs :tabs="[
                'Nieuws',
                'Algemeen',
            ]">

                <div slot="Nieuws">

                    <accordion-input :open="true">
                        <template #label>

                            <div class="font-medium text-gray-600">Limiet</div>

                        </template>
                        <template #content>

                            <input
                                type="text"
                                class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                                placeholder="Standaard = 9; 0 = geen limiet"
                                v-model="options.pagination"
                            />

                        </template>
                    </accordion-input>

                    <accordion-input>
                        <template #label>

                            <div class="font-medium text-gray-600">Categorie</div>

                        </template>
                        <template #content>
                            <div class="mb-2 text-sm text-gray-500 label2">Toon alleen een specifieke categorie nieuws.</div>

                            <select v-model="options.website_news_category_id" class="w-full px-4 py-2 mb-3 border border-gray-300 rounded-md"
                                placeholder="Toon alles"
                            >
                                <option selected value="">Toon alles</option>
                                <option v-for="category in websiteNewsCategories" :key="category.id" :value="category.id">
                                    {{ category.name }}
                                </option>
                            </select>

                        </template>
                    </accordion-input>

                    <accordion-input>
                        <template #label>

                            <div class="font-medium text-gray-600">Type</div>

                        </template>
                        <template #content>
                            
                            <div class="mb-2 text-sm text-gray-500 label2">Toon alleen een specifiek type nieuws.</div>

                            <select v-model="options.website_news_type_id" class="w-full px-4 py-2 mb-3 border border-gray-300 rounded-md"
                                placeholder="Toon alles"
                            >
                                <option selected value="">Toon alles</option>
                                <option v-for="type in websiteNewsTypes" :key="type.id" :value="type.id">
                                    {{ type.name }}
                                </option>
                            </select>

                        </template>
                    </accordion-input>

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        AccordionInput,
    },

    async created() {
        this.websiteNewsCategories = (await axios.get(this.adminUrlPrefix + '/get-website-news-categories')).data;
        this.websiteNewsTypes = (await axios.get(this.adminUrlPrefix + '/get-website-news-types')).data;

        this.options.website_news_category_id = this.options.website_news_category_id || '';
        this.options.website_news_type_id = this.options.website_news_type_id || '';
    },

    data() {
        return {
            websiteNewsCategories: [],
            websiteNewsTypes: [],
        }

    },

}

</script>
